module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Border-b2ef51721be25800d628eee3886f80598eed75de4fdd14d8838c5f7c5e93cdd2.svg";